import SubscriptionsTable from "../../Subscriptions/SubscriptionsTable";

const UserSubscriptions = ({
    subscriptions,
    onEdit,
    onDelete
}) => {
   
    return (
        <div className="mjsdev-dtl-section">
            <div className="mjsdev-dtl-sec-header"><h4>Subscriptions</h4></div>
            <div className="mjsdev-dtl-inner-container">
                <SubscriptionsTable 
                    subscriptions={subscriptions}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            </div>
        </div> 
    );
};

export default UserSubscriptions;
